import stylesheet0 from "@oneappexchange/appx-grid";

export default [stylesheet0];